// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"features-module--iconContainer--3NL9J","parent":"features-module--parent--M-mLO","layout":"features-module--layout--1pqIY","top":"features-module--top--27EIY"};